import { render, staticRenderFns } from "./HeadlineList.vue?vue&type=template&id=10287f80&scoped=true"
import script from "./HeadlineList.vue?vue&type=script&lang=ts"
export * from "./HeadlineList.vue?vue&type=script&lang=ts"
import style0 from "./HeadlineList.vue?vue&type=style&index=0&id=10287f80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10287f80",
  null
  
)

export default component.exports